import styled from '@emotion/styled';
import { colors } from 'Constants/Colors';
import { palette } from '../../../Dashboard.styled';

export const Wrap = styled.div`
  width: 300px;
  flex-shrink: 0;

  @media (max-width: 1100px) {
    width: 100%;
  }
`;

export const BigLine = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;

  b {
    font-size: 32px;
    line-height: 1;
    color: ${palette.ink};
  }

  span {
    font-size: 13px;
    color: ${palette.muted};
  }
`;

export const Track = styled.div`
  display: flex;
  margin-top: 14px;
  height: 12px;
  border-radius: 999px;
  overflow: hidden;
  background: ${palette.track};
`;

export const Segment = styled.div<{ color: string; pct: number }>`
  width: ${({ pct }) => pct}%;
  background: ${({ color }) => color};
  transition: width 0.4s ease;
`;

export const Legend = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-top: 12px;
`;

export const LegendItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: ${palette.muted};

  b {
    color: ${palette.ink};
  }
`;

export const Dot = styled.span<{ color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ color }) => color};
`;

export const SEGMENT_COLORS = {
  approved: palette.green,
  failed: '#d93b3b',
  pending: colors.GRAY_TEXT_FIELD,
};
